import { render, staticRenderFns } from "./admin-module.vue?vue&type=template&id=f801a140&scoped=true&"
import script from "./admin-module.vue?vue&type=script&lang=js&"
export * from "./admin-module.vue?vue&type=script&lang=js&"
import style0 from "./admin-module.vue?vue&type=style&index=0&id=f801a140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f801a140",
  null
  
)

export default component.exports